import { Component, OnInit, OnDestroy } from '@angular/core';
import { BankAcc } from '../../../../../models/BankAcc';
import { Code } from '../../../../../models/Code';

import { AdminService } from '../../../../../services/Admin.service';
import { Router } from '@angular/router';

import { NgForm } from '@angular/forms';
import { ConfirmationPageFailComponent } from '../../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
/*tslint:disable:max-line-length */
import { ConfirmationPageSuccessComponent } from '../../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusyIndicatorComponent } from '../../../../../shared-components/busy-indicator/busy-indicator.component';
/*tslint:enable:max-line-length */

@Component({
  selector: 'app-add-bank-account',
  templateUrl: './add-bank-account.component.html',
  styleUrls: ['./add-bank-account.component.scss']
})
export class AddBankAccountComponent implements OnInit, OnDestroy {
  public bankAccModel: BankAcc = new BankAcc();
  public countryList: Code[];
  public  accountTypeList: Code[];
  public errorMsg: string;
  public successMsg: string;
  private currentYear: number;
  private index: number;
  private _router: Router;
  showFailConfirmation: boolean;
  showSuccessConfirmation: boolean;
  isAccountExists = false;
  private alive = true;

  constructor(private adminSvc: AdminService,
     private router: Router,
    private spinner: NgxSpinnerService) {
      this._router = router;
    }

  ngOnInit() {
    this.getaccountTypes();
    this.getCountries();
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }
  getCountries() {
    this.adminSvc.getCountries()
    .takeWhile(() => this.alive)
    .subscribe(data => {
      this.countryList = data;
    });
  }

  getaccountTypes() {
    this.adminSvc.getBankAccountTypes()
    .takeWhile(() => this.alive)
    .subscribe(data => {
      this.accountTypeList = data;
    });
  }

  checkAccountExists(frmAddBA: NgForm) {
    if (this.bankAccModel.AccountNumber && this.bankAccModel.AccountNumber !== '') {
        this.adminSvc.isBankAccountExists(this.bankAccModel.AccountNumber)
        .takeWhile(() => this.alive)
        .subscribe(
          data => {
                    if (data === true) {
                      this.isAccountExists = true;
                      frmAddBA.controls['bankAccModel.AccountNumber'].setErrors({'incorrect' : true});
                    } else {
                      this.isAccountExists = false;
                      if (!frmAddBA.controls['bankAccModel.AccountNumber'].hasError('pattern') &&
                      !frmAddBA.controls['bankAccModel.AccountNumber'].hasError('required')) {
                        frmAddBA.controls['bankAccModel.AccountNumber'].setErrors(null);
                      }
                    }
                },
          err => {
              this.successMsg = null;
              this.errorMsg = err;
              this.showFailConfirmation = false;
              this.showSuccessConfirmation = false;
          }
        );
    }
  }

  onCancel() {
    this.router.navigate(['/pages/client/my-settings/bank-accounts']);
  }

  onSubmit(frmAddBA: NgForm) {
    this.errorMsg = null;
    this.successMsg = null;
    this.spinner.show();
       this.adminSvc.saveBankAccount(this.bankAccModel)
       .takeWhile(() => this.alive)
       .subscribe(
      data => {
        if (data && data.Message === 'Success') {
                  this.successMsg = 'Bank Account added successfully.';
                  this.errorMsg = null;
                  this.bankAccModel = new BankAcc();
                  this.showSuccessConfirmation = true;
                  this.showFailConfirmation = false;
                  this.spinner.hide();
                } else {
                  this.successMsg = null;
                  this.errorMsg = 'Reason' +  data.Message;
                  this.showSuccessConfirmation = false;
                  this.showFailConfirmation = true;
                  this.spinner.hide();
                }
            },
      err => {
          this.successMsg = null;
          this.errorMsg = err;
          this.showSuccessConfirmation = false;
          this.showFailConfirmation = true;
          this.spinner.hide();
        }
    );
     // window.scrollTo(0, 0);
  }

  goToMyContract(event) {
    this._router.navigate(['/pages/client/my-settings/bank-accounts']);
  }

  close(event) {
    this.showSuccessConfirmation = false;
    this.showFailConfirmation = false;
  }

  public ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/client/my-settings/bank-accounts/add-bank-account/add-bank-account.component.ts